import React from "react";

export const Shape = ({ id, className }: { id: string; className: string }) => (
    <svg
        width="0"
        height="0"
        data-tsid="picture-shape-test-id"
        className={className}
    >
        <clipPath id={id} clipPathUnits="objectBoundingBox">
            <path
                d="M0,0.4 C0,0.26,0,0.19,0.027,0.137 C0.051,0.089,0.089,0.051,0.137,0.027 C0.19,0,0.26,0,0.4,0 H0.6 C0.74,0,0.81,0,0.864,0.027 C0.911,0.051,0.949,0.089,0.973,0.137 C1,0.19,1,0.26,1,0.4 V0.6 C1,0.74,1,0.81,0.973,0.864 C0.949,0.911,0.911,0.949,0.864,0.973 C0.81,1,0.74,1,0.6,1 H0.4 C0.26,1,0.19,1,0.137,0.973 C0.089,0.949,0.051,0.911,0.027,0.864 C0,0.81,0,0.74,0,0.6 V0.4"
                fill="#F7F4F2"
            />
        </clipPath>
    </svg>
);

Shape.displayName = "Picture.Shape";

export default Shape;
